import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setUpdatingContent } from 'ducks/app'
import NotFoundPage from 'pages/DefaultPages/NotFoundPage'

const mapStateToProps = (state, props) => ({
  isLoading: state.app.isLoading,
  user: state.login.user,
  userRole: state.login.role,
  location: state.router.location.pathname,
  company: state.login.company
})

type FunctionOnMounted = () => Promise<any>

@connect(mapStateToProps)
class Page extends React.Component {
  props: {
    roles: Array<string>,
    pathName: any,
    onMounted: ?FunctionOnMounted,
    isNotFound: boolean,
    children: any,
    isLoading: boolean,
    dispatch: Function
  }

  static propTypes = {
    roles: PropTypes.array,
    pathName: PropTypes.any,
    isNotFound: PropTypes.bool,
    onMounted: PropTypes.func,
    children: PropTypes.any,
    // from connect
    isLoading: PropTypes.bool,
    dispatch: PropTypes.func
  }

  static contextTypes = {
    setContentBuffer: PropTypes.func,
  }

  static defaultProps = {
    roles: [],
    pathName: null,
    isNotFound: false,
    onMounted: null,
    isLoading: false,
    dispatch: () => { },
  }

  isFirstContent = true

  updateContent () {
    const { setContentBuffer } = this.context
    const { isNotFound, pathName, children, dispatch } = this.props
    setContentBuffer({ pathName, content: isNotFound ? <NotFoundPage /> : children })
    dispatch(setUpdatingContent(true))
    if (this.isFirstContent) {
      this.isFirstContent = false
      setTimeout(() => window.scrollTo(0, 0))
    }
  }

  componentDidMount() {
    this.updateContent()
  }

  componentDidUpdate() {
    const { isLoading } = this.props
    if (!isLoading) {
      this.updateContent()
    }
  }

  render() {
    return null
  }
}

export default Page
